/*global fetchConfig, routes, publish, PUB_SUB_EVENTS, tingle */
if (!customElements.get('vk-product-form')) {
  customElements.define(
    'vk-product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.customizableFields = document.querySelectorAll('.customizable-field');
        this.canvas = document.querySelector(`#VKCanvas-${this.dataset.sectionId}`);
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]:not([name="share"])');
        this.shareButton = this.querySelector('[type="submit"]:is([name="share"])');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      checkFieldValidationErrors() {
        let hasError = false;
        this.customizableFields.forEach((field) => {
          const validationWrapper = field.closest('.validation-wrapper');
          if (!field.checkValidity()) {
            field.setAttribute('aria-invalid', true);
            field.classList.add('invalid');

            if (validationWrapper) validationWrapper.classList.add('invalid');

            hasError = true;

            if (field.validity.customError) {
              hasError = field.validationMessage;
            }
          } else {
            field.setAttribute('aria-invalid', false);
            field.classList.remove('invalid');

            if (validationWrapper) validationWrapper.classList.remove('invalid');
          }
        });

        return hasError;
      }

      setFormDisabled(disabled) {
        this.submitButton.setAttribute('aria-disabled', disabled);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const clickedButton = evt.submitter;
        const isShareButton = clickedButton.getAttribute('name') === 'share';
        if (this.submitButton.getAttribute('aria-disabled') === 'true' && !isShareButton) return;

        const productImageData = await this.canvas.exportImageData(isShareButton);

        if (!productImageData) {
          this.handleErrorMessage('Image generation is pending, try again in a few seconds.');
          return;
        }

        const validationError = this.checkFieldValidationErrors();

        if (validationError === true) {
          this.handleErrorMessage('All fields are required.');
          return;
        }

        // show custom validation errors
        if (validationError !== false) {
          this.handleErrorMessage(validationError);
          return;
        }

        this.handleErrorMessage();

        // Evertyhing is valid, clear unwanted values and submit the form
        this.customizableFields.forEach((field) => {
          const closestTabContent = field.closest('.tab-content');
          if (closestTabContent && !closestTabContent.dataset.activeType && field.value != '' && field.getAttribute('required') != true) {
            field.value = '';
          }

          if (closestTabContent && closestTabContent.dataset.activeType) {
            const tabType = closestTabContent && closestTabContent.dataset.type;

            // remove the size value on the display field
            if (tabType === 'qr' || tabType === 'image') {
              const fieldset = field.closest('fieldset');
              const alignmentField = document.querySelector(`#${fieldset.dataset.block}-display`);

              alignmentField.value = alignmentField.value.split(' - ')[1];
            }
          }
        });

        // this.submitButton.setAttribute('aria-disabled', true);
        // this.submitButton.classList.add('loading');
        // this.querySelector('.loading__spinner').classList.remove('hidden');
        clickedButton.setAttribute('aria-disabled', true);
        clickedButton.classList.add('loading');
        clickedButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Fulfillment aid for desktop admin: Shopify's desktop order admin renders
        // line-item property values as HTML, which collapses runs of spaces and drops
        // empty lines, hiding the customer's real spacing from the production/engraving
        // team. For every "... Text" property that contains EXTRA whitespace (double
        // spaces, blank lines, or leading/trailing whitespace), append a SEPARATE,
        // additive "(spacing)" property that makes it visible. The original property is
        // left byte-for-byte intact because that exact string is sent to the engraver.
        const VERBATIM_SPACE = '·';        // U+00B7
        const VERBATIM_BREAK = '↵';        // U+21B5 — marker for an empty line

        const hasExtraWhitespace = (raw) => {
          const v = raw.replace(/\r\n/g, '\n');
          return / {2,}/.test(v) || /\n[ \t]*\n/.test(v) || /^\s/.test(v) || /\s$/.test(v);
        };

        const toVerbatim = (raw) =>
          raw
            .replace(/\r\n/g, '\n')
            .split('\n')
            .map((line) => (line === '' ? VERBATIM_BREAK : line.replace(/ /g, VERBATIM_SPACE)))
            .join('\n');

        for (const [key, value] of [...formData.entries()]) {
          if (typeof value !== 'string') continue; // skip File uploads
          if (!/ Text\]$/.test(key)) continue;     // only properties[... Text]
          if (!value) continue;
          if (!hasExtraWhitespace(value)) continue;

          const spacingKey = key.replace(/\]$/, ' (spacing)]');
          formData.append(spacingKey, toVerbatim(value));
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        /* uncomment when we need to extra charge for a customization
        const customizationProducts = [];
        for (const [key, value] of formData.entries()) {
          const customizationProduct = this.getCustomPropertiesExtraItems({ key, value });
          if (customizationProduct) {
            customizationProducts.push(customizationProduct);
          }
        }
        */

        // console.log(formData); //properties[Front Text Bg-Image] //properties[Front Text Crop-Image]

        // are we clicking a share button?
        if (isShareButton) {
          return this.onSubmitGenerateShareImageHandler(config, formData);
        }

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              /* uncomment when we need to extra charge for a customization
              if (customizationProducts.length) {
                await this.addCustomPropertiesExtraItems(customizationProducts);
              }
              */

              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /**
        properties[Preview]: [object File]
        properties[Front Text Display]: Small - Left
        properties[Front Text Bg-Color]:
        properties[Front Text Writing Direction]: Ltr
        properties[Front Text Text]:
        properties[Front Text Image]: [object File]
        properties[Front Text Bg-Image]: [object File]
        properties[Front Text Crop-Image]: [object File]
        properties[Front Text QR]:
      */
      getCustomPropertiesExtraItems(property) {
        const { key, value } = property;

        if (key === 'properties[Front Text Bg-Image]' && value) {
          const propertyName = key.substring(key.indexOf('[') + 1, key.indexOf(']'));
          return {
            id: 44110335967483,
            quantity: 1,
            properties: {
              ['Customization type']: propertyName, // add a line description
            },
          }; // use variant ID of the customization product
        }

        return false;
      }

      addCustomPropertiesExtraItems(customizationProducts) {
        let formData = {
          items: [],
        };

        customizationProducts.forEach((customProduct) => {
          formData.items.push(customProduct);
        });

        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
      }

      async onSubmitGenerateShareImageHandler(config, formData) {
        // console.log('generate share link', config);

        // clear the cart before starting
        // await fetch('/cart/clear', config);

        let customShareObject = null;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // DO NOT NAVIGATE TO CART PAGE
              // window.location = window.routes.cart_url;
              customShareObject = { image: response.properties.Preview, key: response.key };
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.error(e);
          })
          .finally(async () => {
            this.shareButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.shareButton.removeAttribute('aria-disabled');
            this.shareButton.querySelector('.loading-overlay__spinner').classList.add('hidden');

            // const shareImageUrl = currentCart.items[0].properties.Preview;
            // console.log('entrando aqui -3', customShareObject);

            this.handleShareModal(customShareObject.image);

            // delete the item from the cart
            await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ id: customShareObject.key, quantity: 0 }),
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      handleShareModal(shareImageUrl) {
        const modal = new tingle.modal({
          footer: true,
          stickyFooter: false,
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: 'Close',
          cssClass: ['custom-class-1', 'custom-class-2'],
          onOpen: function () {
            // console.log('modal open');
            // load the buttons
            // setTimeout(() => {
            //   console.log('sharethis', shareImageUrl);
            //   // window.__sharethis__.load('inline-share-buttons', sharethisConfig);
            //   window.__sharethis__.initialize();
            // }, 2000);
          },
          onClose: function () {
            // console.log('modal closed');
          },
          beforeClose: function () {
            // here's goes some logic
            // e.g. save content before closing the modal
            return true; // close the modal
            // return false; // nothing happens
          },
        });

        // set content
        // modal.setContent(`
        //   <img src="${shareImageUrl}" width="300" height="300">
        //   <!--div id="sharethis-inline-buttons"
        //     class="sharethis-inline-share-buttons"
        //     data-url="${shareImageUrl}"
        //     data-title="Look at my custom keytag!"
        //   /-->
        //   <div class="st-custom-button" data-network="facebook" data-url="${shareImageUrl}" data-image="${shareImageUrl}">share</div>
        //   <div class="st-custom-button" data-network="twitter" data-url="${shareImageUrl}" data-image="${shareImageUrl}">tweet</div>
        // `);
        modal.setContent(`
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;">
              <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 0 0 6 9c-1.654 0-3 1.346-3 3z"></path>
            </svg>
            Share your custom keytag!
          </h3>
          <img src="${shareImageUrl}" width="300" height="300">
        `);

        // add a button
        modal.addFooterBtn('Download', 'product-form__submit button button--full-width button--secondary', function () {
          // here goes some logic
          // Create an anchor element
          const link = document.createElement('a');

          // Set the href attribute to the image URL
          link.href = shareImageUrl; // Replace with your image URL

          // Set the download attribute to specify the filename
          link.download = 'variouskeytags.png'; // Specify the filename for the downloaded image

          // Programmatically click the anchor element to initiate the download
          link.click();

          modal.close();
          modal.destroy();
        });

        // // add another button
        // modal.addFooterBtn('Dangerous action !', 'tingle-btn tingle-btn--danger', function () {
        //   // here goes some logic
        //   modal.close();
        // });

        // open modal
        modal.open();
      }
    }
  );
}
